<header class="rac__head">
  <h6 class="rac__title">
    <span class="rac__title-icon">
      <i class="fa-solid fa-clock-rotate-left"></i>
    </span>
    {{ titleKey | translate }}
  </h6>

  <div class="rac__head-meta">
    @if (trendPercentage != null) {
      <span class="rac__trend" [class.is-up]="trendPercentage >= 0">
        <i [class]="trendPercentage >= 0
                      ? 'fa-solid fa-arrow-trend-up'
                      : 'fa-solid fa-arrow-trend-down'"></i>
        {{ (trendPercentage >= 0 ? '+' : '') + (trendPercentage | number:'1.0-1') }}%
        <small>{{ 'DASHBOARD.TREND' | translate }}</small>
      </span>
    }
    @if (results.length > 0) {
      <span class="rac__count">{{ results.length }}</span>
    }
  </div>
</header>

@if (results.length > 0) {
  <ul class="rac__list">
    @for (item of results; track $index; let i = $index) {
      <li class="rac__item"
          [class.is-passed]="item.passed"
          [style.animation-delay.ms]="i * 70">

        <span class="rac__icon">
          <i [class]="item.passed ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle-xmark'"></i>
        </span>

        <div class="rac__main">
          <span class="rac__name">{{ item.testTitle }}</span>
          <div class="rac__meta">
            @if (item.subjectName) {
              <span class="rac__chip rac__chip--subject">
                <i class="fa-solid fa-book-open"></i>
                {{ item.subjectName }}
              </span>
            }
            @if (item.testMode) {
              <span class="rac__chip"
                    [class.rac__chip--exam]="item.testMode === 'exam'"
                    [class.rac__chip--eval]="item.testMode !== 'exam'">
                <i [class]="item.testMode === 'exam'
                              ? 'fa-solid fa-graduation-cap'
                              : 'fa-solid fa-clipboard-check'"></i>
                {{ (item.testMode === 'exam' ? 'DASHBOARD.EXAM' : 'DASHBOARD.EVALUATION') | translate }}
              </span>
            }
          </div>
        </div>

        <div class="rac__score">
          <span class="rac__score-num">
            {{ item.percentageScore != null ? (item.percentageScore | number:'1.0-0') + '%' : '—' }}
          </span>
          <div class="rac__bar">
            <span [style.width.%]="item.percentageScore ?? 0"></span>
          </div>
        </div>

      </li>
    }
  </ul>
}
